var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashbaord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4072 19.9413H2.6296C2.27022 19.9413 1.9722 19.6432 1.9722 19.2839C1.9722 18.9245 2.27022 18.6265 2.6296 18.6265H18.4072C18.7666 18.6265 19.0646 18.9245 19.0646 19.2839C19.0646 19.6432 18.7666 19.9413 18.4072 19.9413Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90858 7.34521H3.50613C3.02403 7.34521 2.62959 7.73965 2.62959 8.22175V15.7775C2.62959 16.2596 3.02403 16.654 3.50613 16.654H4.90858C5.39067 16.654 5.78511 16.2596 5.78511 15.7775V8.22175C5.78511 7.73089 5.39067 7.34521 4.90858 7.34521Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2196 4.54932H9.81718C9.33508 4.54932 8.94064 4.94376 8.94064 5.42585V15.7777C8.94064 16.2598 9.33508 16.6542 9.81718 16.6542H11.2196C11.7017 16.6542 12.0962 16.2598 12.0962 15.7777V5.42585C12.0962 4.94376 11.7017 4.54932 11.2196 4.54932Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5307 1.75293H16.1282C15.6461 1.75293 15.2517 2.14737 15.2517 2.62946V15.7775C15.2517 16.2596 15.6461 16.654 16.1282 16.654H17.5307C18.0128 16.654 18.4072 16.2596 18.4072 15.7775V2.62946C18.4072 2.14737 18.0128 1.75293 17.5307 1.75293Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbaord);
export default __webpack_public_path__ + "static/media/dashbaord.ea715fe64b913c11caa5df88a1703bed.svg";
export { ForwardRef as ReactComponent };